module.exports = __webpack_public_path__ + "a7a17f70df5fcd6f7d684b308044afbb.svg";